import axios from "axios";
import React, { FC, useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../workers/WorkerCategories.css"
import editIcon from "../../../assets/img/small-logos/edit_icon.svg"
import deleteIcon from "../../../assets/img/small-logos/delete _icon.svg";
import Swal from "sweetalert2";
import { Button, Col, Row, Form } from "react-bootstrap";
import { Formik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import "../doorstepServices/DoorstepServices.css";
import { FeatureDetail } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Select from "react-select";
import { SingleValue, ActionMeta } from "react-select"
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { formatCategory } from "src/utils/normalFuntions";
import LoadingGif from "src/components/layout/Loader";
interface InitialValuesType {
   name: string;
   type: string;
   description?: string;

}

const getASubscriptionFeatures = async (token: string, type: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/subscription-features`, {
      headers: {
         "x-access-token": token
      },
      params: {
         type
      }

   })
};

const SubscriptionFeatures = () => {
   // const [subCats, setSubCats] = useState<ISubCategory[]>([]);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const [editMode, setEditMode] = useState(false);
   const [features, setFeatures] = useState<FeatureDetail[]>([]);
   const [featureTypes, setFeatureTypes] = useState<string[]>([]);
   const featureType = ["free", "basic", "standard", "premium", "utlra premium"];
   const [modalShow, setModalShow] = useState(false);
   const [selectedType, setSelectedType] = useState("premium");
   const Token = Cookies.get('token');
   const [selectedFeature, setSelectedFeature] = useState<FeatureDetail | null>(null);
   const initialValues: InitialValuesType = {
      name: "",
      type: "",
      description: "",
   };

   const [inputs, setInputs] = useState(initialValues);

   const validationSchema = yup.object().shape({

      name: yup.string()
         .required('Please Fill this field (Name).'),
      description: yup.string().required('Please Fill this field (Description).'),

   });
   const onCreate = () => {
      setEditMode(false);
      setModalShow(true);
      setInputs({
         name: "",
         type: "",
         description: "",

      })
   }
   const onHide = () => {
      setModalShow(false);
      setEditMode(false);
      // setInputs(initialValues);
   }

   useEffect(() => {
      if (Token) {
         dispatch(startLoading());
         getASubscriptionFeatures(Token, selectedType).then((res) => {
            // console.log(res?.data?.data?.data);
            if (res?.data?.status_code === 200) {
              
               setFeatures(res?.data?.data?.data)

               setFeatureTypes(res?.data?.data?.subscriptionTypes);

            }
         })
            .catch((err: any) => {
               console.log(err)
            }).finally(() => dispatch(stopLoading()));
      }
   }, [Token, selectedType])

   const onUpdate = (id: string) => {
      const valuesToEdit = features?.find((value: FeatureDetail) => value?._id === id);
      if (valuesToEdit) {
         setSelectedFeature(valuesToEdit);
         // console.log(id);
         // console.log(valuesToEdit);
         // console.log(inputs)
         // Populate the form fields with the existing data
         setInputs({
            ...inputs,
            name: valuesToEdit?.name || "",
            type: valuesToEdit?.type?.toLocaleLowerCase() as string || "",
            description: valuesToEdit?.description || ""
         });

         setEditMode(true);
         setModalShow(true)
      }
      ;
   };

   const handleDeleteConfirmed = (id: string) => {
   
      if (Token === undefined) {
         console.error("Token is undefined");
         return;
      }
      dispatch(startLoading());
      // Dispatch the delete action here
      Swal.fire({
         title: 'Are you sure?',
         text: "You won't be able to revert this!",
         icon: 'warning',
         showCancelButton: true,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'Yes, delete it!'
      }).then(async (response) => {
         if (response.isConfirmed) {
          
            await axios({
               url: `${AppConfig.DEV_SERVER}/feature/${id}`,
               method: "DELETE",
               headers: {
                  'content-type': 'multipart/form-data',
                  "x-access-token": Token,
               }
            }).then((res) => {
               // console.log(res)
               if (res?.data?.status_code === 200) {
                  Swal.fire(
                     'Deleted!',
                     `${res?.data?.msg}`,
                     'success'
                  )
                     .then(() => window.location.reload())
               } else {
                  Swal.fire(
                     'Something went Wrong!',
                     `${res?.data?.msg}`,
                     'error'
                  )
               }
            }).catch((err) => {
               console.log(err)
            }).finally(() => dispatch(stopLoading()))  // Clear the selectedFoodItem state after updating
            setModalShow(false);
         }
      }
      )
   };


   const handleFormSubmit = async (formInput: any, resetForm: () => void) => {
      const formData = new FormData();

      // console.log(formInput);
      formData.append('name', formInput.name);
      formData.append('type', selectedFeature?.type as string);
      formData.append('description', formInput.description);


      // console.log(formInput);
      if (!Token) return;

      if (!editMode) {
         // Add new food item
         dispatch(startLoading());
         await axios({
            url: `${AppConfig.DEV_SERVER}/add-features`,
            method: "POST",
            data: formData,
            headers: {
               'content-type': 'application/json',
               "x-access-token": Token,
            }
         }).then(async (res) => {

            // console.log(res?.data)
            if (res?.data?.status_code !== 200) {
               setModalShow(false);

               Swal.fire({
                  position: "center",
                  icon: "error",
                  title: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 4000
               }).then(() => {

                  resetForm();

               })
            }
            else {
               if (res?.data?.status_code === 200) {
                  setModalShow(false);

                  Swal.fire({
                     position: "center",
                     icon: "success",
                     title: `${res?.data?.msg}.`,
                     showConfirmButton: false,
                     timer: 1500
                  }).then(() => {
                     window.location.reload()
                     resetForm();

                  })
               }
            }
         }).catch(err => console.log(err)).finally(() => dispatch(stopLoading()))
      } else {
         if (selectedFeature != null) {
            if (selectedFeature?._id) {

               // console.log(selectedFeature);
               await axios({
                  url: `${AppConfig.DEV_SERVER}/feature/${selectedFeature?._id}`,
                  method: "PUT",
                  headers: {
                     'content-type': 'multipart/form-data',
                     "x-access-token": Token,
                  },
                  data: formData,
               }).then(async (res) => {

                  // console.log(res?.data)
                  if (res?.data?.status_code !== 200) {
                     setModalShow(false);
                     Swal.fire({
                        position: "center",
                        icon: "error",
                        title: `${res?.data?.msg}`,
                        showConfirmButton: false,
                        timer: 2000
                     }).then(() => {
                        resetForm();

                     })
                  }
                  else {
                     if (res?.data?.status_code === 200) {

                        setModalShow(false);
                        Swal.fire({
                           position: "center",
                           icon: "success",
                           title: `${res?.data?.msg}.`,
                           showConfirmButton: false,
                           timer: 1500
                        }).then(() => {
                           resetForm();
                           window.location.reload();
                        })
                     }
                  }
               })

            }
         } else {
            console.error("Selected food item or its ID is undefined.");
         }
      }
   }
   //  this below code is for Subscription Category name 
   const handleDropdownChange = (
      newValue: SingleValue<{ label: string | undefined; value: string | undefined }>,
      actionMeta: ActionMeta<{ label: string | undefined; value: string | undefined }>
   ) => {
      setSelectedType(newValue?.value?.toLocaleLowerCase() || '')
      setSelectedFeature({ ...selectedFeature as FeatureDetail, type: newValue?.value?.toLocaleLowerCase() || "" });
      // console.log(newValue?.value);
   };
   const handleDropdownChangeForType = (event: React.ChangeEvent<HTMLSelectElement>) => {
      // setSelectedValue(event.target.value);
      // setSelectedType(event?.target?.value?.toLocaleLowerCase())
      setSelectedFeature({ ...selectedFeature as FeatureDetail, type: event?.target?.value });

      // console.log(event.target.value)
   }

   return (
      <MainLayout>

         <div className="mt-3 mb-3">
            <Formik
               validationSchema={validationSchema}
               onSubmit={(values, { resetForm }) => {
                  handleFormSubmit(values, resetForm)
               }}
               enableReinitialize={true}
               validateOnChange={false}
               validateOnBlur={false}
               initialValues={inputs}
            >
               {({ handleSubmit, handleChange, setFieldValue, values, touched, errors }) => (
                  <Modal show={modalShow} onHide={() => onHide()} size="lg" className="rounded-9 category-modal">
                     <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                           <Modal.Title as="h5">{editMode ? 'Update Feature' : 'Add Feature'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                           <Row className="fieldset-row" >

                              <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="name"> Name</Form.Label>
                                 <Form.Control id="name" type='text' onChange={handleChange} name="name" isValid={touched.name && !errors.name} value={values.name} isInvalid={!!errors.name} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                 </Form.Control.Feedback>
                              </Col>

                              <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="type">Type</Form.Label>
                                 <Form.Select
                                    name="type"
                                    value={values?.type}  // Tie this to Formik's state for consistency
                                    onChange={(event) => {
                                       const { value } = event.target;

                                       setFieldValue('type', value);  // Update Formik's state for 'type'
                                       handleDropdownChangeForType(event);   // Call your custom handler if necessary
                                    }}
                                    isValid={touched.type && !errors.type}
                                    isInvalid={!!errors.type}
                                 >
                                    <option value="" >Select Feature Type</option>
                                    {featureType && featureType.map((value, index) => (
                                       <option key={index} value={value}>
                                          {value?.toLocaleUpperCase()}
                                       </option>
                                    ))}
                                 </Form.Select>
                                 <Form.Control.Feedback type="invalid">
                                    {errors.type}
                                 </Form.Control.Feedback>

                              </Col>

                              <Col md={12} className="mb-2">
                                 <Form.Label htmlFor="description">Description</Form.Label>
                                 <Form.Control id="description" type='text' onChange={handleChange} isValid={touched.description && !errors.description} value={values.description} isInvalid={!!errors.description} />
                                 <Form.Control.Feedback type="invalid">
                                    {errors.description}
                                 </Form.Control.Feedback>
                              </Col>

                           </Row>
                        </Modal.Body>
                        <Modal.Footer>
                           <Button variant="app-warning" type="submit" className="ps-4 pe-4 add-cat-btn" onClick={() => dispatch(startLoading())}>
                              {editMode ? 'Update Value' : 'Add Value'}
                           </Button>
                        </Modal.Footer>
                     </Form>
                  </Modal>
               )
               }
            </Formik >
            <div className="card category-main me-2 p-md-4">
               {
                  loading ? <LoadingGif /> : ""
               }


                  <div className="d-flex justify-content-end mb-2">

                     <div className="d-flex justify-content-end gap-4 w-100 w-xxl-50 ">
                        <div className="d-flex justify-content-end align-items-center w-sm-60 w-md-50 w-xxl-40">
                           <Select
                              name="sub_worker_type"
                              className="type-selecter w-100 w-xl-80"
                              value={{ label: formatCategory(selectedType), value: formatCategory(selectedType) }}
                              onChange={handleDropdownChange}
                              options={featureTypes?.map((value) => ({ label: formatCategory(value), value: formatCategory(value) }))}
                              required
                           />
                        </div>


                        <span className="add-cat" onClick={() => onCreate()}>
                           <button className="add-cat-btn">Add Features</button>
                        </span>

                     </div>

                  </div>
                  <div className="table-extra-responsive">
                     <table className="table table-striped card-body">
                        <thead>
                           <tr className="category-tr">
                              {/* <th scope="col" className="text-start ps-4">name</th> */}
                              <th scope="col" className="text-start ps-4">Feature Id</th>
                              <th scope="col" className="text-start ps-4">Type </th>
                              <th scope="col" className="text-start ps-4">Name </th>
                              <th scope="col" className="text-start ps-4">Description </th>
                              <th scope="col" className="cat_btns">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              features && features?.map((data: FeatureDetail) => {

                                 // const res = Providers?.join(", ")
                                 return (
                                    <tr key={data?._id}>

                                       <td className="text-start ps-4 pt-3">{data?._id}</td>
                                       <td className="text-start ps-4 pt-3">{formatCategory(data?.type)}</td>
                                       <td className="text-start ps-4 pt-3">{data?.name}</td>
                                       {/* <td className="text-start ps-4 pt-3">{data?._id}</td> */}


                                       <td className="text-start ps-4 pt-3">{data?.description?.length !== 0 ? data?.description : "NA"}</td>



                                       <td className="align-content-center ">
                                          <div className="d-flex justify-content-center gap-3">
                                             <button className="btn btn-sm edit_btn" onClick={() => onUpdate(data?._id)}>
                                                <img src={editIcon} />
                                             </button>
                                             {/* <button className="btn btn-sm delete_btn " onClick={() => clickOnShow(data?._id)}>
                                             <img src={eye} />
                                          </button> */}
                                             <button className="btn btn-sm delete_btn " onClick={() => handleDeleteConfirmed(data?._id)}>
                                                <img src={deleteIcon} />
                                             </button>
                                          </div>

                                       </td>
                                    </tr>
                                 )
                              }
                              )
                           }


                        </tbody>
                  </table>
               </div>
            </div>

         </div>

      </MainLayout>
   )

};



export default SubscriptionFeatures;